import React from 'react'

import { type MapCountry } from '../../types'
import { getIndicativeCaseCount } from './mapPresentation'
import styles from './styles.module.scss'

export type MapCalloutPosition = {
  x: number
  y: number
  arrowOffset?: number
}

type MapCalloutProps = {
  country: MapCountry
  position: MapCalloutPosition
  onClose: () => void
  projectsInLabel: string
}

const MapCallout = ({ country, position, onClose, projectsInLabel }: MapCalloutProps) => (
  <div
    className={styles.mapCalloutAnchor}
    style={{ left: `${position.x}px`, top: `${position.y}px` }}
    data-testid="map-callout"
  >
    <div
      className={styles.mapCallout}
      role="tooltip"
      style={{ '--arrow-offset': `${position.arrowOffset ?? 0}px` } as React.CSSProperties}
    >
      <button type="button" aria-label="Close map tooltip" onClick={onClose}>
        ×
      </button>
      <span>{projectsInLabel}</span>
      <strong>{country.name}</strong>
      <b>{country.projectCount || getIndicativeCaseCount(country)}</b>
    </div>
  </div>
)

export default MapCallout
